import { Drawer, Button, Input, Space } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { setIsChartOpen } from "@/store/modules/user";
import { useState, useRef, useEffect } from "react";
import styles from "./index.module.scss";
import roboat from "@/assets/images/service.png";
import classNames from "classnames";
import moment from "moment";
import profile from "@/assets/images/profile.png";
import intl from "react-intl-universal";

const RoabotChart = () => {
  const dispatch = useDispatch();
  const { isChartOpen } = useSelector((state) => state.user);
  const { avatar } = useSelector((state) => state.user);
  const [keywords, setKeywords] = useState("");
  const [type, setType] = useState("1");
  const [messageList, setMessageList] = useState([
    {
      local: 1,
      msg: intl.get("Intelligent des"),
      time: "2021-01-01 08:00:00",
    },
  ]);
  const onClose = () => {
    dispatch(setIsChartOpen(false));
  };

  const sendMessage = () => {
    setKeywords("");
    dealMsg(keywords);
  };

  const dealMsg = async (msg) => {
    const obj = {
      local: 2,
      msg: msg,
      time: moment().format("YYYY-MM-DD HH:mm:ss"),
    };
    const arr = [...messageList, obj];
    setMessageList(arr);
    setTimeout(() => {
      const obj2 = {
        local: 1,
        msg: "think...",
        time: moment().format("YYYY-MM-DD HH:mm:ss"),
      };
      setMessageList([...arr, obj2]);
    }, 1000);

    if (type === "1") {
      docChat(arr, msg);
    } else {
      ogeChat(arr, msg);
    }
  };

  // 文档问答
  const docChat = (arr, msg) => {
    const time = moment().subtract(1, "day").format("YYYY-MM-DD HH:mm:ss");
    // fetch("http://10.101.240.63:7861/chat/kb_chat", {//能通
    fetch("/docai/chat/kb_chat", {
      //不能通
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        query: msg, // 主要变化内容,用户输入的问题
        // "query": "What is the OGC API - Features?",  // 主要变化内容,用户输入的问题
        mode: "local_kb",
        kb_name: "OGC_Standards",
        top_k: 3,
        score_threshold: 2,
        history: [],
        stream: true,
        model: "deepseek-r1:32b-4k",
        temperature: 0.7,
        max_tokens: 0,
        prompt_name: "default",
        return_direct: false,
      }),
    })
      .then(async (res) => {
        const reader = res.body.getReader();
        const decoder = new TextDecoder();
        let content = "";
        let isThinking = true;
        while (isThinking) {
          // 读取数据流的第一块数据，done表示数据流是否完成，value表示当前的数
          const { done, value } = await reader.read();

          if (done) {
            isThinking = false;
            break;
          }
          const text = decoder.decode(value);
          if (text.includes("data:")) {
            const msgObj = JSON.parse(text.split("data:")[1]);

            // let docs = msgObj?.docs
            // let html = ""
            // if (docs && docs.length > 0) {
            // 	docs.forEach(item => {
            // 		html += `<div>${item}</div>`
            // 	})
            // }

            let msg = msgObj.choices[0]?.delta?.content;
            content = content + msg;
            const obj = {
              local: 1,
              msg: content,
              time: time,
            };
            setMessageList([...arr, obj]);
          }
        }
      })
      .catch((err) => {
        const obj = {
          local: 1,
          msg: "抱歉，问题解析失败!",
          time: time,
        };
        setMessageList([...arr, obj]);
      });
  };

  // oge解决方案
  const ogeChat = async (arr, msg) => {
    const time = moment().subtract(1, "day").format("YYYY-MM-DD HH:mm:ss");
    fetch("/ogeai/agent/stream", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        question: msg
      }),
    })
      .then(async (res) => {
        const reader = res.body.getReader();
        const decoder = new TextDecoder();
        let content = "";
        let isThinking = true;
        while (isThinking) {
          // 读取数据流的第一块数据，done表示数据流是否完成，value表示当前的数
          const { done, value } = await reader.read();
          if (done) {
            isThinking = false;
            break;
          }
          const text = decoder.decode(value,{ stream: true });
          if (text.includes("data:")) {
			  // const msgObj = JSON.parse(text.split("data:")[1]);
			  // content = content + msgObj.data;
			  const msgObj = parseDataJson(text);
			//   console.log()
            content = content + msgObj;
            const obj = {
              local: 1,
              msg: content.replace(/\n/g, ''),
              time: time,
            };
            setMessageList([...arr, obj]);
          }
        }
      })
      .catch((err) => {
		console.log(err)
        const obj = {
          local: 1,
          msg: intl.get("Sorry, problem resolution failed"),
          time: time,
        };
        setMessageList([...arr, obj]);
      });
  };

  const parseDataJson = (inputString)=>{
	const regex = /"data": "([^"]+)"/g;
	let matches;
	const results = [];
	while ((matches = regex.exec(inputString))!== null) {
		results.push(matches[1].replace(/\\n/g, '<br>'));
	}
	return results.join('')
  }
  const handleKeyDown = (e) => {
    if (e.keyCode === 13) {
      sendMessage();
    }
  };

  const messagesEndRef = useRef(null);
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  useEffect(scrollToBottom, [messageList]);
  return (
    <Drawer
      title={intl.get("Intelligent Assistant")}
      onClose={onClose}
      width={580}
      open={isChartOpen}
    >
      <div className={styles.chartBox}>
        {messageList.map((item) => {
          return (
            <div
              key={item.time}
              className={classNames(
                "flex_box",
                item.local === 2 && "flex_end",
                item.local === 1 ? styles.leftBox : styles.rightBox
              )}
            >
              {item.local === 1 && <img src={roboat} />}
              <div dangerouslySetInnerHTML={{ __html: item.msg }} />
              {item.local === 2 && (
                <img
                  src={
                    avatar && avatar !== "undefined"
                      ? process.env.REACT_APP_API_AFFIX+"/file/preview?filePath=" + avatar
                      : profile
                  }
                />
              )}
            </div>
          );
        })}
        <div ref={messagesEndRef}></div>
      </div>
      <div className={styles.btnBox}>
        <span
          onClick={() => {
            setType("1");
          }}
          className={type === "1" && styles.active}
        >
          {intl.get("Document question answering")}
        </span>
        <span
          onClick={() => {
            setType("2");
          }}
          className={type === "2" && styles.active}
        >
          {intl.get("OGE's solution")}
        </span>
      </div>
      <Space.Compact style={{ width: "100%", marginTop: 15 }}>
        <Input
          allowClear
          onKeyDown={handleKeyDown}
          value={keywords}
          onChange={(e) => {
            setKeywords(e.target.value);
          }}
        />
        <Button type="primary" onClick={sendMessage}>
          {intl.get("Send")}
        </Button>
      </Space.Compact>
    </Drawer>
  );
};
export default RoabotChart;
